import "./QuoteTotalsComponent.scss";
import template from "./QuoteTotalsComponent.html";
import {IComponentOptions} from "angular";
import {QuoteViewModel} from "../../models/QuoteViewModel";

export const QuoteTotals = "tfQuoteTotals";

export function quoteTotals(): IComponentOptions {
    return {
        template,
        bindings: {
            model: "<quote"
        },
        controllerAs: "ctrl",
        controller: QuoteTotalsComponentController
    };
}

export class QuoteTotalsComponentController {
    /** @input */
    public readonly model: QuoteViewModel;
}
